import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';

export const Torque = () => {
  HighchartsMore(Highcharts);
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'gauge',
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: '500px',
    },
    title: {
      text: ''
  },

  pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ['50%', '75%'],
      size: '110%'
  },

  // the value axis
  yAxis: {
      min: 0,
      max: 200,
      tickPixelInterval: 72,
      tickPosition: 'inside',
      tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
          distance: 20,
          style: {
              fontSize: '14px'
          }
      },
      lineWidth: 0,
      plotBands: [{
          from: 0,
          to: 120,
          color: '#55BF3B', // green
          thickness: 20
      }, {
          from: 120,
          to: 160,
          color: '#DDDF0D', // yellow
          thickness: 20
      }, {
          from: 160,
          to: 200,
          color: '#DF5353', // red
          thickness: 20
      }]
  },

  series: [{
      name: 'Torque',
      data: [80],
      tooltip: {
          valueSuffix: ' Kw/Rpm'
      },
      dataLabels: {
          format: '{y} Kw/Rpm',
          borderWidth: 0,
          color: (
              Highcharts.defaultOptions.title &&
              Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color
          ) || '#333333',
          style: {
              fontSize: '16px'
          }
      },
      dial: {
          radius: '80%',
          backgroundColor: 'gray',
          baseWidth: 12,
          baseLength: '0%',
          rearLength: '0%'
      },
      pivot: {
          backgroundColor: 'gray',
          radius: 6
      }

  }]


  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      setChartOptions((prevOptions) => {
        const newOptions = { ...prevOptions };
        const point = newOptions.series[0].data[0];
        const inc = Math.round((Math.random() - 0.5) * 20);

        let newVal = point + inc;
        if (newVal < 0 || newVal > 200) {
          newVal = point - inc;
        }

        newOptions.series[0].data = [newVal];
        return newOptions;
      });
    }, 3000);

    return () => clearInterval(intervalId); 
  }, []);

  return (
    <div >
      <h1 className='text-center mt-5'> Engine Torque</h1>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};
